import { render } from "./KanoonFinanceCard.vue?vue&type=template&id=1fe54a9c"
import script from "./KanoonFinanceCard.vue?vue&type=script&lang=js"
export * from "./KanoonFinanceCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"KanoonFinanceCard.vue"]])

export default __exports__